module.exports = __webpack_public_path__ + "img/create-application.fe61b150.png";